import { render, staticRenderFns } from "./PropTable.vue?vue&type=template&id=0c2f9dc4&scoped=true&"
import script from "./PropTable.vue?vue&type=script&lang=js&"
export * from "./PropTable.vue?vue&type=script&lang=js&"
import style0 from "./PropTable.vue?vue&type=style&index=0&id=0c2f9dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f9dc4",
  null
  
)

export default component.exports